import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DocumentGroupingConfiguration {
  required: boolean;
  validityRule: string;
  filesPerBorrower: number;
  documentTypeId: string;
}

export interface DocumentGrouping {
  id: string;
  name: string;
  configuration: DocumentGroupingConfiguration[];
  userId: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

export interface GetDocumentGroupingByIdParams {
  id: string;
}

export interface GetDocumentGroupingByIdResponse {
  success: boolean;
  grouping: DocumentGrouping;
}

const getDocumentGroupingById: QueryFunction<
  GetDocumentGroupingByIdResponse,
  ['/document-groupings', GetDocumentGroupingByIdParams]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const { id } = queryKey[1];
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<GetDocumentGroupingByIdResponse>(
    `/document-groupings/${id}`,
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to fetch document grouping');
};

export default getDocumentGroupingById;

const _mockData: GetDocumentGroupingByIdResponse = {
  success: true,
  grouping: {
    id: 'mock-1',
    name: 'Sample Document Stack',
    configuration: [
      {
        required: true,
        validityRule: 'valid',
        filesPerBorrower: 1,
        documentTypeId: 'doc-type-1',
      },
    ],
    userId: 'user-123',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    isDeleted: false,
  },
};
